export default "__VITE_ASSET__CNYXWBJK__"